<template>
  <div>
    <div class="header">
      <div class="head_warp">
        <div class="head_title">
          {{ $store.state.eduWebConfig.eduWebConfigInfo.webName }}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="warp" style="height: calc(100vh - 140px)">
        <div class="back-head">
          <h3>测评登记</h3>
          <p>请输入您的登记号确认身份信息后，点击下一步进行测评。</p>
          <div>
            <!-- 基本信息验证 -->
            <el-form
              ref="form"
              :model="outsiderForm"
              :rules="outsiderFormRules"
              label-width="100px"
            >
              <el-form-item label="登记号：" prop="taskOutsideRelId">
                <el-input
                  v-model="outsiderForm.taskOutsideRelId"
                  placeholder="请输入登记号"
                  style="width: 675px"
                ></el-input>
              </el-form-item>
              <div v-if="isShowOutsiderInfo">
                <el-form-item label="身份证号：">
                  <el-input
                    v-model="outsiderForm.idcard"
                    disabled
                    style="width: 675px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="姓名：">
                  <el-input
                    v-model="outsiderForm.name"
                    disabled
                    style="width: 675px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="性别：">
                  <el-input
                    v-model="outsiderForm.sexName"
                    disabled
                    style="width: 675px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="年龄：">
                  <el-input
                    v-model="outsiderForm.age"
                    disabled
                    style="width: 675px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系电话：">
                  <el-input
                    v-model="outsiderForm.contact"
                    disabled
                    style="width: 675px"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="next">
            <div v-if="!isShowOutsiderInfo">
              <el-button @click="backToLogin()" class="next_btn"
                >返回</el-button
              >
              <el-button
                type="primary"
                @click="getOutsiderUserInfo()"
                class="next_btn"
                >确 定</el-button
              >
            </div>
            <div v-else>
              <el-button
                type="primary"
                @click="getOutsiderUserInfo()"
                class="next_btn"
                >重新获取</el-button
              >
              <el-button type="primary" @click="startTask()" class="next_btn"
                >开始测评</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_line"></div>
    <div class="main-footer">
      <p>
        <a target="_bank" href="https://beian.miit.gov.cn"
          >蜀ICP备20012822号-4</a
        >
      </p>
      <p>
        <a href="http://www.bluerhyme.net/" target="_bank"
          ><img class="bottom_logo" src="/static/images/logo_icon.png" />{{
            $store.state.eduWebConfig.eduWebConfigInfo.scaleAlias
              ? "四川心海蓝韵信息科技有限公司"
              : "四川蓝韵心理咨询服务有限公司"
          }}</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      provinceList: [],
      cityList: [],
      countyList: [],
      schoolList: [],
      gradeList: [],
      classList: [],
      isShowOutsiderInfo: false,
      outsiderForm: {
        taskOutsideRelId: null,
      },

      outsiderRuleForm: {
        pass: "",
        checkPass: "",
      },
      outsiderFormRules: {
        taskOutsideRelId: [
          { required: true, message: "请输入登记号", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    // 返回登录页
    backToLogin() {
      this.$router.replace("/login");
    },
    // 开始测评任务
    startTask() {
      if (!this.outsiderForm.taskId)
        return this.$message.error("未查询到测评信息！ ");
      this.$router.push({
        name: "answerList",
        query: {
          taskInfo: encodeURIComponent(JSON.stringify(this.outsiderForm)),
        },
      });
    },

    // 获取校外人员测评信息
    getOutsiderUserInfo() {
      if (!this.outsiderForm.taskOutsideRelId)
        return this.$message.info("请输入登记号！");
      this.$request
        .get("taskSvrRoot/scalemmpt/taskInfo/verifyTaskOutsider", {
          params: {
            taskOutsideRelId: this.outsiderForm.taskOutsideRelId,
          },
        })
        .then((res) => {
          if (res) {
            res.taskOutsideRelId = this.outsiderForm.taskOutsideRelId;
            this.outsiderForm = res;
            this.outsiderForm.sexName = this.$LYCom.getSexName(
              this.outsiderForm.sex
            );
            this.isShowOutsiderInfo = true;
          } else {
            this.outsiderForm = {
              taskOutsideRelId: this.outsiderForm.taskOutsideRelId,
              idcard: "",
              name: "",
              age: "",
              contact: "",
              sex: "",
            };
            this.$message.error("获取登记信息错误，请联系管理员！");
          }
        })
        .catch((err) => {
          this.outsiderForm = {
            taskOutsideRelId: this.outsiderForm.taskOutsideRelId,
            idcard: "",
            name: "",
            age: "",
            contact: "",
            sex: "",
          };
          this.$message.error(err.msg);
        });
    },
  },
};
</script>
 
<style scoped>
.warp {
  width: 980px;
  margin: 0 auto;
}
.header {
  height: 70px;
  box-shadow: 0px 5px 15px #b3c6fc;
  color: white;
  background-image: url(/static/images/header_bg.jpg);
  z-index: 99;
  position: relative;
}
.head_warp {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 15px;
}
.head_title {
  font-size: 24px;
}
.content .warp {
  background: url(/static/images/container_bg.png) repeat-y;
  padding: 0 4px 0 100px;
}
.back-head {
  padding-top: 60px;
  line-height: 100%;
}
.back-head h3 {
  font-size: 20px;
  font-weight: 400;
}
.back-head p {
  margin: 15px 0 60px;
  font-size: 16px;
  color: #333;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #000;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #091d7c;
}

.next {
  width: 780px;
  text-align: center;
}
.next_btn {
  padding: 12px 50px;
}
.area_list {
  display: flex;
  width: 675px;
}
.class_warp {
  width: 675px;
  display: flex;
}
.radio_warp {
  margin: 20px 0;
}
.area_list .el-select,
.class_warp .el-select {
  flex: 1;
}

.el-outsiderForm-item {
  margin-bottom: 30px;
}

.rest_title {
  font-size: 20px;
  padding: 10px;
  height: 40px;
  line-height: 40px;
  width: 780px;
  margin: 20px 0;
}
.footer_line {
  height: 10px;
  background: linear-gradient(left, #000147, #1cb4df);
}

.main-footer {
  height: 30px;
  text-align: center;
  margin-top: 10px;
}
.main-footer a {
  font-size: 13px;
  color: #999999;
  text-decoration: none;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #746b6b !important ;
}
</style>


// WEBPACK FOOTER //
// src/views/outsideranswer/AnswerRegister.vue